import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import { TranslateConfigService } from "../../home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body",
    templateUrl: "./default.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class DefaultComponent implements OnInit {
    selectedLang: string;

    constructor(
        private service: TranslateConfigService,
        private translate: TranslateService
    ) {
        let language = this.translate.getBrowserLang();
        let value = localStorage.getItem(LNG_KEY);
        if (value === "" || value === null || value === undefined) {
            this.translate.setDefaultLang(language);
            this.selectedLang = language;
        } else {
            this.service.setLanguage(value);
            this.selectedLang = value;
        }
        let val = localStorage.getItem(LNG_KEY);
    }
    ngOnInit() {

    }

}